import React, {Component} from "react";
import FlexView from "react-flexview";
import {generateYearOptions, getTableConfigSpecific, monthOptions} from "../config";
import * as R from "ramda";
import {mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import Api from "../../../../../Services/Api";
import {fetchDataAsync} from "../../../../../Services/Utils";
import {HttpStatus} from "../../../../common/Constants";

class CashFlowMonitoring extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            tableConfig: [],
            month: null,
            year: null,
            yearOptions: generateYearOptions(),
            total: 0,
            totalRealise: 0,
            totalNonRealise: 0,
            totalPrinted: 0,
            totalCancelled: 0,
            pagination: {
                totalData: 0,
                page: 1,
                limit: 5,
            },
        }
    };

    async componentDidMount() {
        const monthIndex = new Date().getMonth();
        const fullYear = new Date().getFullYear();
        await this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: getTableConfigSpecific(this.props.tab),
            month: monthOptions[monthIndex],
            year: mapToObjectDDL(fullYear, fullYear),
        }));
    };

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(this.props.kodeCabang, prevProps.kodeCabang)) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: [],
                total: 0,
                totalRealise: 0,
                totalNonRealise: 0,
                totalPrinted: 0,
                totalCancelled: 0,
                pagination: {
                    totalData: 0,
                    limit: 5,
                    page: 1,
                }
            }));
        }

        if (prevState.pagination.page !== this.state.pagination.page ||
            prevState.pagination.limit !== this.state.pagination.limit
        ) {
            await this.fetchData();
        }
    };

    handleChangePeriod = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    fetchData = async () => {
        this.props.triggerLoading();
        const {tab} = this.props;
        const req = removeNullFields({
            kodeCabang: this.props.kodeCabang,
            month: this.state.month?.value,
            year: this.state.year?.value,
            limit: this.state.pagination.limit,
            page: this.state.pagination.page,
        });
        const asyncFn = tab === "bkk"
            ? Api.create("NAGAMAS_REPORT_DTO").getMonitoringBKKCashier
            : tab === "bkm"
                ? Api.create("NAGAMAS_REPORT_DTO").getMonitoringBKMCashier
                : tab === "bbk"
                    ? Api.create("NAGAMAS_REPORT_DTO").getMonitoringBBKCashier
                    : tab === "bbm"
                        ? Api.create("NAGAMAS_REPORT_DTO").getMonitoringBBMCashier
                        : null;
        let res = await fetchDataAsync({
            asyncFn,
            menuName: `Dashboard Cashier - Monitoring ${tab.toUpperCase()}`,
            setError: this.props.setError,
            args: req,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let {data, totalData} = res.data;
            let returnVar = `data${tab.toUpperCase()}`;
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: data[returnVar],
                total: data.jumlahKwitansi,
                totalRealise: data.jumlahKwitansiRealisasi,
                totalNonRealise: data.jumlahKwitansiBelumRealisasi,
                totalPrinted: data.jumlahKwitansiCetak,
                totalCancelled: data.jumlahKwitansiBatal,
                pagination: {
                    ...prevValue.pagination,
                    totalData: totalData,
                }
            }));
        }
        this.props.triggerLoading();
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    render() {
        return (
            <>
                <FlexView style={{alignItems: "center", marginBottom: "15px", gap: "10px"}}>
                    <SimpleDDL
                        name="month"
                        box="search"
                        label="Bulan"
                        isClearable
                        containerclassname="width width-200px"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, {name}) => this.handleChangePeriod(name, value)}
                    />
                    <SimpleDDL
                        name="year"
                        box="search"
                        label="Tahun"
                        isClearable
                        containerclassname="width width-200px"
                        options={this.state.yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleChangePeriod(name, value)}
                    />
                    <SimpleButton styles={{marginTop: "5px"}} onClick={this.fetchData}>Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    columns={this.state.tableConfig}
                    data={this.state.dataTable}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                />
                <FlexView column style={{marginTop: "15px"}}>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Jumlah Total Kuitansi                  :  ${this.state.total}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Jumlah Total Kuitansi Belum Realisasi  :  ${this.state.totalNonRealise}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Jumlah Total Kuitansi Sudah Realisasi  :  ${this.state.totalRealise}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Jumlah Total Kuitansi Sudah Dicetak    :  ${this.state.totalPrinted}`}
                    </p>
                    <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                        {`Jumlah Total Kuitansi Batal            :  ${this.state.totalCancelled}`}
                    </p>
                </FlexView>
            </>
        );
    };
}

export default CashFlowMonitoring;